/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { routePaths } from './route-paths';

const home = React.lazy(() => import('../../views/home/home.container'));
const aboutUs = React.lazy(() => import('../../views/about-us/aboutUs.container'));
const policies = React.lazy(
  () => import('../../views/policies-terms-and-agreements/policies-terms-and-agreements.container'),
);
// const aiSolution = React.lazy(() => import('../../views/ai-solution/aiSolution.container'));
const healthcareProvidersContainer = React.lazy(
  () => import('../../views/healthcare-providers/healthcareProviders.container'),
);
const PharmaceuticalsContainer = React.lazy(
  () => import('../../views/pharmaceuticals/pharmaceuticals.container'),
);
const contactUs = React.lazy(() => import('../../views/contact-us/contactUs.container'));
const news = React.lazy(() => import('../../views/news-v2/news-v2.container'));
const research = React.lazy(() => import('../../views/research/research.container'));
const login = React.lazy(() => import('../../views/login/login.component'));
const logout = React.lazy(() => import('../../views/logout/logout.component'));
const download = React.lazy(() => import('../../views/download/download.container'));

const PrivacyPolicyContainer = React.lazy(
  () => import('../../views/documents/privacy-policy/privacyPolicy.container'),
);

type RoutePath = {
  path: string;
  name: string;
  component?: any;
  exact?: boolean;
};

const routes: RoutePath[] = [
  { path: '/', exact: true, name: '', component: home },
  { path: routePaths.AboutUs, name: 'AboutUs', component: aboutUs },
  // { path: routePaths.AiSolution, name: 'AiSolution', component: aiSolution },
  {
    path: routePaths.HealthcareProviders,
    name: 'HealthcareProviders',
    component: healthcareProvidersContainer,
  },
  { path: routePaths.Pharmaceuticals, name: 'PharmasCROs', component: PharmaceuticalsContainer },
  { path: routePaths.Contact, name: 'ContactUs', component: contactUs },
  { path: routePaths.News, name: 'News', component: news, exact: true },
  { path: '/logincallback', name: 'Login', component: login },
  { path: '/logoutcallback', name: 'Logout', component: logout },
  { path: routePaths.PrivacyPolicy, name: 'PrivacyPolicy', component: PrivacyPolicyContainer },
  { path: routePaths.download, name: 'Download', component: download },
  { path: routePaths.Policies, name: 'PolicesTermsAndAgreements', component: policies },
  { path: routePaths.Research, name: 'Research', component: research },
];

export default routes;
